import http from './index'

async function get(urlKey, params = {}) {
    try {
        const res = await http.get(urlKey, { params })
        return res
    } catch (err) {
        return Promise.reject(err)
    }
}

async function post(urlKey, data = {}) {
    try {
        const res = await http.post(urlKey, data)
        return res
    } catch (err) {
        return Promise.reject(err)
    }
}

// 统一在末尾导出一个对象
export default {
    get,
    post
}